import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['panel']

  toggle (event) {
    event.preventDefault()
    const hidden = this.panelTarget.classList.toggle('hidden')
    if (!hidden) this.panelTarget.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  close (event) {
    if (event) event.preventDefault()
    this.panelTarget.classList.add('hidden')
  }
}
